const features = {
  ' ': {
    forms: {
      title: 'Number of forms',
      help_text: 'Create as many Paperforms as you need across all our plans. ',
    },

    /* views: {
      title: 'Form Views / month',
      help_text:
        'The number of times your form can be viewed. The limit is reset at the beginning of your billing month. Form views only count if someone else views the form.',
    }, */
    users: {
      title: 'Users',
      help_text:
        'Be a lone wolf, or upgrade to invite people to your account and collaborate on Paperforms. ',
    },
    submissions: {
      title: 'Submissions / month',
      help_text:
        'The number of submissions you can receive on a monthly basis from the first day of the billing month.',
    },
    payment_submissions: {
      title: 'Payment Submissions / month',
      help_text:
        'The number of submissions that include payments you can receive on a monthly basis from the first day of the billing month.',
    },
    appointment_submissions: {
      title: 'Appointment Submissions / month',
      help_text:
        'Schedule bookings, manage availability, and create events that sync directly to your calendar. This is the number of submissions that include appointments you can receive on a monthly basis from the first day of the billing month.',
    },

    annual_submissions: {
      title: 'Submissions / year',
      help_text:
        'The number of submissions you can receive on a yearly basis from the first day of the billing year.',
    },
    annual_payment_submissions: {
      title: 'Payment Submissions / year',
      help_text:
        'The number of submissions that include payments you can receive on a yearly basis from the first day of the billing year.',
    },
    annual_appointment_submissions: {
      title: 'Appointment Submissions / year',
      help_text:
        'Schedule bookings, manage availability, and create events that sync directly to your calendar. This is the number of submissions that include appointments you can receive on a yearly basis from the first day of the billing year.',
    },

    /* appointments: {
      title: 'Appointment Field (Bookings / Scheduling)',
      help_text:
        'Schedule bookings, manage availability, and create events that sync directly to your calendar.',
    }, */
    submission_storage: {
      title: 'Submissions Storage',
      help_text:
        'The maximum number of submissions you can store on Paperform at one time.',
    },
    total_file_storage: {
      title: 'Upload Storage',
      help_text:
        'The maximum total size of uploaded files that can be collected from users.',
    },
    /* storage: {
      title: 'Upload Storage',
      help_text:
        'Unlimited storage of form data across all plans. Each plan has a limited amount of results that are stored.',
    }, */
    remove_branding: {
      title: 'Paperform Branding',
      help_text: `Remove the 'Powered by Paperform' footer from your Paperforms.`,
    },

    /* payment_accounts: {
      title: 'Number of Payment Accounts',
      help_text:
        'Connect multiple payment accounts to your Paperform account to send money where you need it to go. ',
    }, */
    integration_count: {
      title: '2000+ integrations',
      help_text:
        'Connect your Paperforms to your favourite apps and software via direct integrations, Zapier, and Make. ',
    },
    support: {
      title: 'Live Support With Form Experts',
      help_text:
        'Get an answer or a solution from our industry-leading Customer Success team via live chat.',
    },
    domains: {
      title: 'Custom Domain Support',
      help_text: 'Setup a custom domain for your Paperforms',
    },
    html_css: {
      title: 'Custom HTML & CSS',
      help_text:
        'Add custom HTML and CSS for a fine level of control over the styling of your Paperforms, success pages, custom PDFs, and email responses.',
    },
    webhooks: {
      title: 'Webhooks',
      help_text:
        'Use our Webhooks to send responses to compatible URLs and web apps. ',
    },
    api: {
      title: 'Standard API access',
      help_text:
        'Access our REST API to programatically retrieve forms, submissions, and partial submissions. ',
    },
    business_api: {
      title: 'Business API access',
      help_text:
        'Automate and organize your form processes with the Business API.',
    },
    sso_addon: {
      title: 'SSO (SAML)',
      help_text: 'Streamline user access across your organization.',
    },

    dedicated_csm: {
      title: 'Dedicated CSM',
      help_text:
        'Get a dedicated Customer Success Manager to help you succeed.',
    },
    sla: {
      title: 'SLA',
      help_text: 'Service Level Agreement, uptime and support guarantees.',
    },
    local_data_residency: {
      title: 'Local Data Residency',
      help_text:
        'Choose to have your account set up in a specific region for data residency.',
    },
    custom_permissions: {
      title: 'Advanced User Permissions & Admin Features',
      help_text:
        'Assign roles and manage users to more easily control access across your team. ',
    },

    /* max_file_size: {
      title: 'Maximum File Size',
      help_text:
        'The maximum files size that can be collected from users when using the Upload File question field.',
    }, */
  },
  'AI Features': {
    ai_form_creation: {
      title: 'Form Creation',
      help_text:
        'Describe what you want in natural language and let AI generate the form for you.',
    },
    ai_calculations: {
      title: 'Calculations Assistant',
      help_text: 'Use AI to help you setup calculation fields for your forms.',
    },
    ai_report_insights: {
      title: 'Report Insights',
      help_text: 'Use AI to generate insights from your form results.',
    },
  },
  'Logic & Power Features': {
    pagination: {
      title: 'Multiple Pages and Conditional Content',
      help_text:
        'Create multi-page forms and personalize content based on how people answer. ',
    },
    guided_mode: {
      title: 'Guided Mode (one question at a time)',
      help_text:
        'A one question at a time experience perfect for conversational, mobile-friendly surveys. ',
    },
    logic: {
      title:
        'Conditional Logic (for questions, content, emails, summaries, and more)',
      help_text:
        'Show and hide questions, content, emails, summaries, and more, or trigger specific actions, based on responses. Ideal for automating workflows. ',
    },
    required_conditional: {
      title: 'Required & Conditional questions',
      help_text: 'Set questions as required, or allow them to be optional.',
    },
    scoring: {
      title: 'Scoring',
      help_text:
        'Attribute values to responses to calculate scores. Perfect for quizzes!',
    },

    autoclose_number: {
      title: 'Auto-close submissions (based on number)',
      help_text:
        'Automatically close submissions after a certain number of entries has been reached. ',
    },
    calculations: {
      title: 'Calculations Field',
      help_text:
        'Use functions and operators to make Excel-style calculations based on form responses. The potential is limitless. ',
    },
    autoclose_date: {
      title: 'Auto-close submissions (based on date)',
      help_text: 'Automatically close submissions on a certain date.',
    },
  },
  'Form Experience': {
    fields: {
      title: '26 Field Types',
      help_text: "And we're adding more all the time",
    },
    ai_form_creation: {
      title: 'AI Form Creation',
      help_text:
        'Describe what you want in natural language and let AI generate the form for you.',
    },
    answer_piping: {
      title: 'Answer Piping',
      help_text:
        'Insert or "pipe" answer text from a previous question into a later part of your Paperform to personalize and streamline. ',
    },
    share: {
      title: 'Share forms via link, Facebook or Twitter',
      help_text:
        'Personalize meta descriptions and share Paperform link previews online, and on social media. ',
    },
    prefill: {
      title: 'Pre-filling & Hidden Fields',
      help_text:
        'Auto-generate responses based on previous fields, existing data (for example, from your CRM), or the URL respondents came from to provide a personalized experience.',
    },
    captcha: {
      title: 'ReCAPTCHA',
      help_text:
        'Activate ReCAPTCHA to protect your Paperforms from fraud or abuse. ',
    },

    oembed: {
      title: 'OEmbed Support',
      help_text: 'Easily embed your Paperforms on external websites. ',
    },
    wordpress: {
      title: 'Wordpress Plugin',
      help_text:
        'Add Paperforms to your WordPress website or blog with our native Plugin. ',
    },
    save_resume: {
      title: 'Automatic Save & Resume for Respondents',
      help_text:
        'Automatically save data so respondents can return and complete forms at their convenience. ',
    },
    appointments: {
      title: 'Appointment Field (Bookings / Scheduling)',
      help_text:
        'Schedule appointments of any type and integrate directly with your Google Calendar. Book meetings, holidays, or entire events automatically. ',
    },

    esignature: {
      title: 'Signature field',
      help_text: 'Allow people to draw their signatures on your forms.',
    },
    color_picker: {
      title: 'Color Picker Field',
      help_text:
        'Pre-define swatches and allow respondents to choose custom colours. Ideal for design requests, vendors, and order forms. ',
    },
    calculations: {
      title: 'Calculations Field',
      help_text:
        'Make calculations based on how respondents answer. Ideal for auto-generating appointment durations and service quotes. ',
    },
    ai_calculations: {
      title: 'AI Calculations Assistant',
      help_text: 'Use AI to help you setup calculation fields for your forms.',
    },
    dynamic_success_pages: {
      title: 'Dynamic Success (Thank you) Page',
      help_text:
        'Create custom success pages with additional styling options that can also be conditionally used depending on how the form was answered. ',
    },
    closed_messaging: {
      title: 'Submissions closed custom messaging',
      help_text: 'Set custom messaging for when form submissions have closed. ',
    },
    google_address_search: {
      title: 'Google Address Search',
      help_text:
        'Enable autocomplete to address fields - improve accuracy and make it easier for respondents to fill out your forms. ',
    },
    external_options_list: {
      title: 'API Powered Dropdowns',
      help_text: 'Power dropdowns on you forms with your own API',
    },
  },
  'Brand and Design Customisation': {
    templates: {
      title: 'Template Gallery',
      help_text:
        'Access to a constantly expanding library of beautiful Paperform templates across a broad spectrum of use cases. ',
    },
    form_sharing: {
      title: 'Form Sharing (make your own templates)',
      help_text:
        'Make forms for others to use, either specific people, or everyone.',
    },
    rich_media: {
      title:
        'Add Images, GIFs & Videos to Forms (Body, background, products, questions, and more)',
      help_text:
        'Use slash commands to easily insert visual media anywhere within Paperform—including question fields, backgrounds, products and more. ',
    },
    giphy: {
      title: 'Import direct from Unsplash & Giphy',
      help_text:
        'Browse and import millions of royalty-free images and GIFs directly within the Paperform editor. ',
    },
    image_editor: {
      title: 'Image editor',
      help_text: 'Edit and markup images natively within the Paperform editor.',
    },
    adobe: {
      title: 'Access Adobe Creative Cloud Libraries',
      help_text:
        'Get access to shared images, assets and colors from Adobe Creative Cloud Libraries to keep Paperforms on-brand. ',
    },
    translation: {
      title: 'Translate Forms and UI (Language support)',
      help_text:
        'Customize the messaging and buttons of your Paperforms to display in any language. ',
    },
    advanced_themeing: {
      title: 'Advanced Design & Theme Forms',
      help_text: `Curate your Paperform's unique look and feel by adding your logo, tweaking colours and fonts, and uploading visual media. Save templates to quickly create and apply custom themes.`,
    },
    form_url: {
      title: 'Custom Form Link (URL)',
      help_text:
        'Personalize your Paperform link for wherever you decide to share it online.',
    },
    domains: {
      title: 'Custom Domain Support',
      help_text: 'Setup a custom domain for your Paperforms',
    },
  },
  'Data Management & Automation': {
    integrations: {
      title: '2000+ Integrations (Native, Zapier & Make)',
      help_text:
        'Connect your Paperforms to your favourite apps with native integrations, or integrate with 4,000+ tools with Zapier, and Make. ',
    },
    results: {
      title: 'Submission Results and Reports',
      help_text:
        'Analyze results and generate reports for deeper insights into form performance and user behaviour. ',
    },
    ai_report_insights: {
      title: 'AI Report Insights',
      help_text: 'Use AI to generate insights from your form results.',
    },
    export: {
      title: 'Export submission results',
      help_text:
        'Create, download and print submission results in CSV, PDF or .DOC, and automatically send results to other apps using integrations. ',
    },
    notifications: {
      title: 'Submission Notifications',
      help_text:
        'Receive customizable submission summary emails whenever a form is submitted. ',
    },
    emails: {
      title: 'Email Responses (send emails to anyone, including respondents)',
      help_text:
        'Send emails to anyone upon submission, and automate follow up emails when respondents complete your Paperform. ',
    },
    byo: {
      title: "Disable Paperform's submission storage (BYO)",
      help_text:
        'Store submission information on your own systems, and use Zapier or Webhooks to transfer submissions to your own databases. ',
    },
    spaces: {
      title: 'Form Spaces and Tag Management',
      help_text:
        'Manage your Paperform workspace to keep all your projects organized.',
    },
    redirects: {
      title: 'Simple Submission Redirects',
      help_text: 'Redirect respondents to a another page after submission.',
    },
    third_party_analytics: {
      title: 'Google Analytics & Facebook Pixel Support',
      help_text:
        'Integrate with Google Analytics & Facebook Pixel to track performance, measure conversions, and optimize marketing campaigns. ',
    },
    custom_analytics: {
      title: 'Custom Analytics',
      help_text:
        'Add custom third-party analytics and conversion tracking scripts to your Paperforms. ',
    },
    conditional_redirects: {
      title: 'Conditional and Timed Submission Redirects',
      help_text:
        'Redirect respondents to different URLs based on their previous answers, and after your specifiied time. ',
    },
    paperform_analytics: {
      title: 'Paperform Analytics',
      help_text:
        'Gain insight into user behaviour, form performance and drop-off questions so you can optimize your Paperforms. ',
    },
    custom_pdfs: {
      title: 'Custom PDFs',
      help_text:
        'Design and auto generate custom PDFs that can be attached to emails, downloaded from the form submission page, or automatically sent to third-party apps through integrations. ',
    },
    partial_submissions: {
      title: 'Partial Submissions',
      help_text:
        'View partial response data from when people leave without completing your Paperform. ',
    },

    webhooks: {
      title: 'Webhooks',
      help_text:
        'Use our Webhooks to send responses to compatible URLs and web apps. ',
    },
    mult_user: {
      title: 'User Permissions and Management',
      help_text:
        'Assign roles and manage users to more easily control access across your team. Agency only. ',
    },
    api: {
      title: 'Standard API access',
      help_text:
        'Access our REST API to programatically retrieve forms, submissions, and partial submissions. ',
    },
    business_api: {
      title: 'Business API access',
      help_text:
        'Automate and organize your form processes with the Business API.',
    },
    byo_s3: {
      title: 'Custom S3 Storage (BYO)',
      help_text:
        'Store file uploads and exports from submissions in your own S3 bucket.',
    },
  },
  'Payment Features': {
    products: {
      title: 'Product Sales and Management (eCommerce)',
      help_text:
        'Add products, manage inventory, and run your store or restaurant directly within Paperform. ',
    },
    price: {
      title: 'Price and Donation Fields',
      help_text:
        'Accept payments of all types with Paperform. Set a fixed price, or give your audience the chance donate a sum of their choice. No additional fees. ',
    },
    pricing_rules: {
      title: 'Custom Pricing Rules',
      help_text:
        'Use question logic to personalize prices and add additional fees. Ideal for service-based businesses. ',
    },
    subscriptions: {
      title: 'Subscriptions',
      help_text:
        'Let customers anywhere set up recurring payments—daily, weekly, monthly or annually, or as a set of installments.',
    },
    quotes: {
      title: 'Quotes / Invoices (Non-processed Payments)',
      help_text:
        'Provide your customers with a price estimate, including any discounts or taxes.',
    },
    coupons: {
      title: 'Coupon and discounts on payments and subscriptions',
      help_text:
        'Create coupons and discount codes to share with your customers.',
    },
    tax: {
      title: 'Tax Calculations for Payments and Subscriptions',
      help_text:
        'Automate taxes on your Paperform transactions to make compliance easy. ',
    },
    stripe: {
      title: 'Stripe Payments',
      help_text:
        'Stripe makes borderless payments a breeze, with 135+ currencies, and 8 payment methods supported. ',
    },
    gpay: {
      title: 'Google Pay',
      help_text:
        'Use Google Pay to checkout without having to enter any payment information. ',
    },
    braintree: {
      title: 'Braintree Payments',
      help_text:
        'The only payment platform that delivers PayPal, Venmo, credit cards, and digital wallets like Apple Pay and Google Pay in a single integration. ',
    },
    paypal: {
      title: 'PayPal Business Payments',
      help_text:
        'PayPal Commerce Platform is built to simplify payments for businesses of all sizes. Includes fraud and seller protection for added peace of mind. ',
    },
    square: {
      title: 'Square Payments',
      help_text:
        'Accept web payments and POS payments in store quickly, easily, and securely, with Square. ',
    },
    refunds: {
      title: 'Issue Refunds',
      help_text:
        'Change of mind? Refund customer charges in full from Paperform.',
    },
    _3dsecure: {
      title: '3D Secure support for Braintree and Stripe',
      help_text:
        'Ask customers to complete an additional verification step when paying for extra fraud protection. ',
    },
  },
  Security: {
    soc2: {
      title: 'SOC 2 Compliant',
      help_text:
        'Our tools are SOC 2 Type II compliant, ensuring the security of your data.',
    },
    gdpr: {
      title: 'GDPR Compliant',
      help_text: `Our tools comply with the GDPR's requirements to ensure the safety of your data. `,
    },
    ssl: {
      title: 'Enhanced Security (SSL Encryption)',
      help_text:
        'Communications between our servers and your browser are protected with SSL encryption.',
    },
    twofa: {
      title: '2FA',
      help_text:
        'Go beyond usernames and passwords to ensure the security of your Paperform account. ',
    },
    enforce_2fa: {
      title: 'Require 2FA of all users',
      help_text:
        'Activate to require all users to use two-factor authentication to verify their identities.',
    },
    sso_addon: {
      title: 'SSO (SAML)',
      help_text: 'Streamline user access across your organization.',
    },
  },
};

export const papersignFeatures = {
  ' ': {
    signed_monthly_documents: {
      title: 'Signed monthly documents',
      help_text:
        'Just get a few documents signed each month, or go Pro* for as many as you like through the UI or Paperform integration, subject to fair usage.',
    },
    api_monthly_documents: {
      title: 'API signed documents',
      help_text:
        'Get documents signed programmatically through our API. Perfect for high-volume users.',
    },
    users: {
      title: 'Users',
      help_text: '',
    },
    upload_sign: {
      title: 'Upload and sign PDFs',
      help_text: '',
    },
    rich_editor: {
      title: 'Rich editor to create and sign documents from scratch',
      help_text: '',
    },
    activity_trail: {
      title: 'Activity Trail',
      help_text: '',
    },
    tracking_notifications: {
      title: 'Real-time tracking and notifications',
      help_text: '',
    },
    email_chat_support: {
      title: 'Email/Chat Support',
      help_text: '',
    },
    signed_document_certificate: {
      title: 'Signed Document Certificate',
      help_text: '',
    },
    paperform_integration: {
      title: 'Paperform integration to automate document signing',
      help_text: '',
    },
    soc2: {
      title: 'SOC 2 Compliant',
      help_text:
        'Our tools are SOC 2 Type II compliant, ensuring the security of your data.',
    },
    gdpr: {
      title: 'GDPR Compliant',
      help_text: `Our tools comply with the GDPR's requirements to ensure the safety of your data. `,
    },
    reminders: {
      title: 'Automatic Reminders',
      help_text: 'Send automatic email reminders to signers.',
    },
    consent_agreement: {
      title: 'Consent Agreement',
      help_text: 'Add a consent agreement to your documents.',
    },
    document_organisation: {
      title: 'Document Organisation',
      help_text: 'Organize your documents into folders.',
    },
    papersign_api: {
      title: 'Papersign API',
      help_text:
        'Automate and organize your document signing processes with the Papersign API.',
    },
    bulk_sending: {
      title: 'Bulk Sending',
      help_text: 'Send multiple documents to multiple recipients in one go.',
    },

    custom_email_notifications: {
      title: 'Custom Email Notifications',
      help_text: 'Customize the email notifications sent to signers.',
    },
    signer_email_verification: {
      title: 'Signer Email Verification',
      help_text:
        'Require signers to verify their email address before signing.',
    },
    manual_signing_links: {
      title: 'Manual Signing Links',
      help_text: 'Generate manual signing links for signers.',
    },

    webhooks: {
      title: 'Webhooks',
      help_text:
        'Use our Webhooks to be notified when documents are signed or completed.',
    },
    sso: {
      title: 'SSO (SAML)',
      help_text: 'Streamline user access across your organization.',
    },
    dedicated_csm: {
      title: 'Dedicated CSM',
      help_text:
        'Get a dedicated Customer Success Manager to help you succeed.',
    },
    sla: {
      title: 'SLA',
      help_text: 'Service Level Agreement, uptime and support guarantees.',
    },
    multi_region: {
      title: 'Local Data Residency',
      help_text: 'Choose to have your account set up in a specific region.',
    },
  },
};

export default features;

export const paperformPlusFeatures = {
  ' ': {
    client_teams: {
      title: 'Client Teams',
    },
    demo_teams: {
      title: 'Demo Teams',
    },
    branding: {
      title: 'Access to all branding and management features',
    },
  },
};
